function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 7175 6290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1463.89,-1816.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.05882,0,-138.953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7204.72,2512.14C7204.72,2429.39 7133.59,2362.2 7045.96,2362.2L2520.97,2362.2C2433.34,2362.2 2362.2,2429.39 2362.2,2512.14L2362.2,6228.01C2362.2,6310.77 2433.34,6377.95 2520.97,6377.95L7045.96,6377.95C7133.59,6377.95 7204.72,6310.77 7204.72,6228.01L7204.72,2512.14Z",
    style: {
      fill: "rgb(78,165,232)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "89.01px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2362.2,2775.59L7204.72,2834.65C7243.64,4034.94 7069.99,5111.45 6614.17,6023.62C6460.84,6270.79 6335.94,6413.76 6259.84,6377.95L2362.2,6377.95C2185.86,6403.23 1232.53,6489.42 1653.54,5905.51C2181.7,5173.02 2446.96,4318.47 2362.2,2775.59Z",
    style: {
      fill: "rgb(246,246,246)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "166.67px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.205882,0,1875.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7204.72,2512.14C7204.72,2429.39 7190.89,2362.2 7173.85,2362.2L2393.08,2362.2C2376.04,2362.2 2362.2,2429.39 2362.2,2512.14L2362.2,6228.01C2362.2,6310.77 2376.04,6377.95 2393.08,6377.95L7173.85,6377.95C7190.89,6377.95 7204.72,6310.77 7204.72,6228.01L7204.72,2512.14Z",
    style: {
      fill: "rgb(255,18,18)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "213.55px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1.14286,-1102.36,-269.966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3661.42,2096.46C3661.42,1982.38 3582.03,1889.76 3484.25,1889.76C3386.47,1889.76 3307.09,1982.38 3307.09,2096.46L3307.09,2509.84C3307.09,2623.92 3386.47,2716.53 3484.25,2716.53C3582.03,2716.53 3661.42,2623.92 3661.42,2509.84L3661.42,2096.46Z",
    style: {
      fill: "rgb(246,246,246)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "117.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1.14286,1377.95,-269.966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3661.42,2096.46C3661.42,1982.38 3582.03,1889.76 3484.25,1889.76C3386.47,1889.76 3307.09,1982.38 3307.09,2096.46L3307.09,2509.84C3307.09,2623.92 3386.47,2716.53 3484.25,2716.53C3582.03,2716.53 3661.42,2623.92 3661.42,2509.84L3661.42,2096.46Z",
    style: {
      fill: "rgb(246,246,246)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "117.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.815789,0,0,0.770833,1047.45,19.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9212.6,5192.6C9212.6,4934.2 9014.37,4724.41 8770.2,4724.41L5166.8,4724.41C4922.64,4724.41 4724.41,4934.2 4724.41,5192.6L4724.41,9925.51C4724.41,10183.9 4922.64,10393.7 5166.8,10393.7L8770.2,10393.7C9014.37,10393.7 9212.6,10183.9 9212.6,9925.51L9212.6,5192.6Z",
    style: {
      fill: "rgb(246,246,246)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "189.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-177.165,-2185.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5551.18,9448.82L5905.51,9803.15L6614.17,8976.38",
    style: {
      fill: "none",
      stroke: "rgb(62,216,0)",
      strokeWidth: "333.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-177.165,-3608.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5551.18,9448.82L5905.51,9803.15L6614.17,8976.38",
    style: {
      fill: "none",
      stroke: "rgb(62,216,0)",
      strokeWidth: "333.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-177.165,-4901.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5551.18,9448.82L5905.51,9803.15L6614.17,8976.38",
    style: {
      fill: "none",
      stroke: "rgb(62,216,0)",
      strokeWidth: "333.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.666667,0,0,0.666667,2185.04,590.551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8858.27,5403.54C8858.27,5354.65 8818.58,5314.96 8769.68,5314.96L7175.2,5314.96C7126.31,5314.96 7086.61,5354.65 7086.61,5403.54L7086.61,5580.71C7086.61,5629.6 7126.31,5669.29 7175.2,5669.29L8769.68,5669.29C8818.58,5669.29 8858.27,5629.6 8858.27,5580.71L8858.27,5403.54Z",
    style: {
      fill: "rgb(63,183,211)",
      stroke: "rgb(0,23,114)",
      strokeWidth: "137.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.577778,0,0,0.666667,2814.96,1062.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8858.27,5403.54C8858.27,5354.65 8812.47,5314.96 8756.06,5314.96L7188.82,5314.96C7132.41,5314.96 7086.61,5354.65 7086.61,5403.54L7086.61,5580.71C7086.61,5629.6 7132.41,5669.29 7188.82,5669.29L8756.06,5669.29C8812.47,5669.29 8858.27,5629.6 8858.27,5580.71L8858.27,5403.54Z",
    style: {
      fill: "rgb(63,183,211)",
      stroke: "rgb(0,23,114)",
      strokeWidth: "146.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7,0,0,0.666667,1889.76,1948.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8858.27,5403.54C8858.27,5354.65 8820.47,5314.96 8773.9,5314.96L7170.98,5314.96C7124.42,5314.96 7086.61,5354.65 7086.61,5403.54L7086.61,5580.71C7086.61,5629.6 7124.42,5669.29 7170.98,5669.29L8773.9,5669.29C8820.47,5669.29 8858.27,5629.6 8858.27,5580.71L8858.27,5403.54Z",
    style: {
      fill: "rgb(63,183,211)",
      stroke: "rgb(0,23,114)",
      strokeWidth: "134.11px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.513333,0,0,0.666667,3212.6,2421.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8858.27,5403.54C8858.27,5354.65 8806.72,5314.96 8743.23,5314.96L7201.66,5314.96C7138.16,5314.96 7086.61,5354.65 7086.61,5403.54L7086.61,5580.71C7086.61,5629.6 7138.16,5669.29 7201.66,5669.29L8743.23,5669.29C8806.72,5669.29 8858.27,5629.6 8858.27,5580.71L8858.27,5403.54Z",
    style: {
      fill: "rgb(63,183,211)",
      stroke: "rgb(0,23,114)",
      strokeWidth: "154.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8125,0,0,0.666667,1033.46,3366.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8858.27,5403.54C8858.27,5354.65 8825.7,5314.96 8785.58,5314.96L7159.3,5314.96C7119.18,5314.96 7086.61,5354.65 7086.61,5403.54L7086.61,5580.71C7086.61,5629.6 7119.18,5669.29 7159.3,5669.29L8785.58,5669.29C8825.7,5669.29 8858.27,5629.6 8858.27,5580.71L8858.27,5403.54Z",
    style: {
      fill: "rgb(63,183,211)",
      stroke: "rgb(0,23,114)",
      strokeWidth: "123.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.866667,0,0,0.666667,649.606,3838.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8858.27,5403.54C8858.27,5354.65 8827.74,5314.96 8790.13,5314.96L7154.76,5314.96C7117.15,5314.96 7086.61,5354.65 7086.61,5403.54L7086.61,5580.71C7086.61,5629.6 7117.15,5669.29 7154.76,5669.29L8790.13,5669.29C8827.74,5669.29 8858.27,5629.6 8858.27,5580.71L8858.27,5403.54Z",
    style: {
      fill: "rgb(63,183,211)",
      stroke: "rgb(0,23,114)",
      strokeWidth: "118.56px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.33333,0,0,0.321429,-11909.4,2817.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3661.42,2303.15C3661.42,2075 3650.25,1889.76 3636.5,1889.76L3332,1889.76C3318.25,1889.76 3307.09,2075 3307.09,2303.15C3307.09,2531.3 3318.25,2716.53 3332,2716.53L3636.5,2716.53C3650.25,2716.53 3661.42,2531.3 3661.42,2303.15Z",
    style: {
      fill: "rgb(35,35,35)",
      stroke: "rgb(6,6,6)",
      strokeWidth: "24.26px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.e64178f81bf35284f5b6f58cd0fbe6ba.svg";
export { ForwardRef as ReactComponent };